/**
 * A correction is a per-person override that beats Vantagepoint and Azure AD
 * everywhere in the app. Which fields are overridden was previously only visible
 * by opening the editor; People & access now shows the count on the row, so the
 * arithmetic lives here where it can be tested.
 *
 * The stored patch uses null to mean "no override", not absent — setCorrection
 * writes explicit nulls to clear a field, so an existence check would count a
 * cleared field as a correction.
 */

export const CORRECTABLE_FIELDS = ['department', 'jobTitle', 'managerId', 'topOfOrg'];

export function correctedFieldCount(correction) {
  if (!correction) return 0;
  return CORRECTABLE_FIELDS.filter((field) => correction[field] != null).length;
}
